/**
 * Utility functions related to Express Entry draw data.
 */

// Define aliases for long stream names to improve mobile readability
const DRAW_NAME_ALIASES = {
  'Provincial Nominee Program': 'PNP',
  'French language proficiency': 'French Prof.',
  'Canadian Experience Class': 'CEC',
  'Healthcare occupations': 'Healthcare',
  'Trade occupations': 'Trades',
  'STEM occupations': 'STEM',
  'Transport occupations': 'Transport',
  'Agriculture and agri-food occupations': 'Agri-Food',
  'Federal Skilled Worker': 'FSW',
  'Federal Skilled Trades': 'FST',
  // Keep 'General' and 'No Program Specified' as they are short
};


/**
 * Formats a draw name by removing the "(Version X)" suffix and applying shorter aliases.
 * Example: "French language proficiency (Version 1)" becomes "French Prof."
 *
 * @param {string | undefined | null} name - The original draw name.
 * @returns {string} The formatted draw name, or 'N/A' if the input is null/undefined.
 */
export const formatDrawName = (name) => {
  if (!name) return 'N/A';
  // Regex explanation:
  // \s* : Matches zero or more whitespace characters before the parenthesis
  // \(  : Matches the opening parenthesis literally
  // Version : Matches the word "Version"
  // \s* : Matches zero or more whitespace characters after "Version"
  // \d+ : Matches one or more digits (the version number)
  // \)  : Matches the closing parenthesis literally
  // \s* : Matches zero or more whitespace characters after the parenthesis
  // $   : Anchors the match to the end of the string
  // i   : Makes the match case-insensitive
  // Ensure name is a string before attempting to use string methods
  const cleanedName = typeof name === 'string' ? name.replace(/\s*\(Version\s*\d+\)\s*$/i, '').trim() : String(name || '').trim();
  // Apply alias if one exists for the cleaned name
  return DRAW_NAME_ALIASES[cleanedName] || cleanedName;
};

// Add other draw-related utility functions here if needed in the future.